import { GlobalSearchType } from '../enum/global-search.enum';
import { Pagination } from './api-response.model';
import { ArticleModel } from './article.model';
import { ListFilter, ListFilterModel } from './filter.model';
import { GuideModel } from './guide.model';
import { NewsModel } from './news.model';
import { CourseListingDetailModel } from './webinar-course.model';

export interface TabMenuInterface {
    id: GlobalSearchType;
    title: string;
    count: number;
}

export interface RecentSearchInterface {
    id: number;
    text: string;
}

export interface HotTopicInterface {
    id: string;
    lookupItemType: GlobalSearchType;
    title: string;
}

export interface GlobalSearchFilterInterface extends ListFilter {
    lookupItemType: GlobalSearchType;
    searchKey: string;
    sortType?: number;
}

export class GlobalSearchFilterModel extends ListFilterModel {
    lookupItemType: GlobalSearchType = GlobalSearchType.All;
    searchKey: string;
    sortType: number = 0;

    constructor(model: GlobalSearchFilterInterface = {} as GlobalSearchFilterInterface) {
        super({
            skip: model.skip || 0,
            take: model.take || 8,
            paging: model.paging ?? true,
            startDate: model.startDate,
            endDate: model.endDate,
            searchBy: model.searchBy,
            searchString: model.searchString,
        });

        this.lookupItemType = model.lookupItemType;
        this.searchKey = model.searchKey;
        this.sortType = model.sortType ?? 0;
    }
}

export class HotTopicModel {
    id: string;
    lookupItemType: GlobalSearchType;
    title: string;
    linkToPage: string;

    constructor(model: HotTopicInterface) {
        this.id = model.id;
        this.lookupItemType = model.lookupItemType;
        this.title = model.title;
        this.linkToPage = this.setLink(model);
    }

    private setLink(model: HotTopicInterface): string {
        switch (model.lookupItemType) {
            case GlobalSearchType.Articles:
                return '/resource/article/' + model.id;

            case GlobalSearchType.Courses:
                return '/program/course/details/' + model.id;
            // Missing condition for routing to live or recorded webinar page, will need BE side to return the info
            case GlobalSearchType.Webinars:
                return '/program/live/details/' + model.id;

            case GlobalSearchType.QuickGuides:
                return '/resource/quick-guide' + "?search=" + model.title + "&isShow=true";

            case GlobalSearchType.TaxAMinutes:
                return '/resource/tax-a-minute' + "?search=" + model.title;
        }

        return '';
    }
}

export interface GlobalSearchResultInterface {
    articles: Pagination<ArticleModel[]>;
    courses: Pagination<CourseListingDetailModel[]>;
    quickGuides: Pagination<GuideModel[]>;
    taxAMinutes: Pagination<NewsModel[]>;
    webinars: Pagination<CourseListingDetailModel[]>;
}
